import { LanguageIcon } from '@heroicons/react/24/outline';
import { postDataAPI } from '../../Helpers/FetchAPI';
import React, { useState } from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/solid';

export const TranslateButton = ({ text, language, onResponse }) => {
  const [loading, setLoading] = useState(false);
  return (
    <div
      className="__translate-button absolute top-1 right-1 size-12 cursor-pointer rounded-full p-2 hover:bg-gray-200"
      onClick={() => {
        setLoading(true);
        postDataAPI(`/api/translate`, { text, language })
          .then((res) => {
            return res.data;
          })
          .then((data) => {
            onResponse(data.translation);
            setLoading(false);
          });
      }}
    >
      <ArrowPathIcon
        className={`absolute top-1/2 left-1/2 size-8 -translate-1/2 transition-all duration-300 ease-out ${loading ? 'animate-spin opacity-100' : 'opacity-0'}`}
      />
      <LanguageIcon
        className={`absolute top-1/2 left-1/2 size-8 -translate-1/2 transition-all duration-300 ease-out ${loading ? 'opacity-0' : 'opacity-100'}`}
      />
    </div>
  );
};
